import { getBonusxApiConfigV2 } from "../../../../common/bonusxApiConfig";
import { Mapper } from "../../../../utils/mapper";
import { IApiClientService } from "../../../ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../AxiosApiClientInstance/AxiosApiClientInstance";
import { ClientConstantCmsDto } from "../../dtos/client-constant.dto";
import { IClientConstantsRemoteDatasource } from "./client-constants-remote.datasource.interface";

export class ClientConstantsRemoteDatasource implements IClientConstantsRemoteDatasource {
  private readonly _OPTIONS = getBonusxApiConfigV2();
  private readonly _REQUEST_TIMEOUT_SECONDS = 2;
  private readonly _REQUEST_TIMEOUT_MILLISECONDS = this._REQUEST_TIMEOUT_SECONDS * 1000;
  private readonly _GET_CLIENT_CONSTANTS_URL = `/client-constants`;

  constructor(private readonly _client: IApiClientService = new AxiosApiClientInstance()) {}

  async getAllClientConstants(): Promise<ClientConstantCmsDto[]> {
    const { data } = await this._client.get<ClientConstantCmsDto[]>(this._GET_CLIENT_CONSTANTS_URL, {
      ...this._OPTIONS,
      timeout: this._REQUEST_TIMEOUT_MILLISECONDS,
    });

    if (!data) {
      throw new Error("Client constants not available");
    }

    const mappedDtos: ClientConstantCmsDto[] = Mapper.mapArrayData(ClientConstantCmsDto, data);

    return mappedDtos;
  }
}
